import { PluginName } from './plugin-name';
import type { PluginExtraInfo, PluginInvocation } from './types';

/**
 * Extracts search results from plugin invocations.
 * Finds the search plugin and parses its plugin_extra_info to get searchResults.
 */
export const getSearchResultsFromPlugins = (
	pluginInvocations: PluginInvocation[] | undefined,
): PluginExtraInfo | null => {
	if (!Array.isArray(pluginInvocations)) {
		return null;
	}

	const searchPlugin = pluginInvocations.find((plugin) => plugin.plugin_name === PluginName.SEARCH);

	if (!searchPlugin?.plugin_extra_info) {
		return null;
	}

	try {
		return JSON.parse(searchPlugin.plugin_extra_info) as PluginExtraInfo;
	} catch {
		return null;
	}
};
